export default __webpack_public_path__ + "static/assets/412ee5930b9fa148f90b2152d1d7d950.png";